import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function ServicePage() {
  return (
    <>
      {/* Hero Banner */}
      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Our Services</h1>
          <p>Explore our wide range of professional services tailored for your needs</p>
        </div>
      </section>

   {/* Main Services Section */}
      <section className="services-section">
          <div className="services-container">
             <div className="service-category">
                  <div className="services-grid">

                 {/* Facility Management Software (FMS) */}
                  <div  className="service-card">                    
                      <h3>Facility Management Software (FMS)</h3>
                        <p>Ideal for hospitals, commercial buildings & institutions:
                          <ul>
                            <li>Asset Management</li>
                            <li>AMC Tracking</li>
                            <li>Ticket/Complaint Management</li>
                            <li>Preventive Maintenance Scheduling</li>
                            <li>Vendor Management</li>
                          </ul>
                        </p>
                  </div>


      {/* Supply Chain Management */}
      <div className="service-card">
        <h3>Supply Chain Management (SCM)</h3>
        <p>Efficiently manage procurement, inventory, vendors, logistics, and distribution with real-time tracking and analytics.</p>
      </div>

      {/* Hospital Management Software */}
      <div className="service-card">
        <h3>Hospital Management Software (HMS)</h3>
        <p>Complete digital hospital solution including:</p>
        <ul>
          <li>Patient Registration & EMR</li>
          <li>Billing & Accounts</li>
          <li>Pharmacy Management</li>
          <li>Laboratory Management</li>
          <li>IPD / OPD Management</li>
          <li>Reports & Analytics</li>
        </ul>
      </div>

      {/* Visitor Management System */}
      <div className="service-card">
        <h3>Visitor Management System</h3>
        <p>Secure and track visitor entry with:</p>
        <ul>
          <li>Digital Gate Pass</li>
          <li>QR Code Access</li>
          <li>Visitor Logs & Reports</li>
          <li>Real-Time Monitoring</li>
        </ul>
      </div>

      {/* Email Servicing Platform */}
      <div className="service-card">
        <h3>Email Servicing Platform</h3>
        <p>Enterprise email management system:</p>
        <ul>
          <li>Custom Domain Emails</li>
          <li>Secure SMTP/IMAP</li>
          <li>Admin Control Panel</li>
          <li>Spam Protection & Backup</li>
        </ul>
      </div>

      {/* Ticket / Breakdown Management Software */}
      <div className="service-card">
        <h3>Ticket / Breakdown Management Software</h3>
        <p>Track complaints and service breakdowns with:</p>
        <ul>
          <li>Ticket Generation</li>
          <li>Priority Management</li>
          <li>SLA Tracking</li>
          <li>Technician Assignment</li>
          <li>Performance Reports</li>
        </ul>
      </div>

      {/* Project Management Software */}
      <div className="service-card">
        <h3>Project Management Software (PMC)</h3>
        <p>Designed for Project Monitoring & Consultancy:</p>
        <ul>
          <li>Work Progress Tracking</li>
          <li>BOQ Management</li>
          <li>Billing & RA Bills</li>
          <li>Document Management</li>
          <li>Reporting Dashboard</li>
        </ul>
      </div>

      {/* Construction Management Software */}
      <div className="service-card">
        <h3>Construction Management (CMC) Rate Analysis Software</h3>
        <p>For contractors and construction companies:</p>
        <ul>
          <li>Rate Analysis</li>
          <li>Material & Labor Costing</li>
          <li>BOQ Preparation</li>
          <li>Tender Estimation</li>
          <li>Profit Analysis</li>
        </ul>
      </div>

      {/* Restaurant Management Software */}
      <div className="service-card">
        <h3>Restaurant Management Software</h3>
        <p>Complete restaurant operations system:</p>
        <ul>
          <li>Billing & POS</li>
          <li>Kitchen Order Tickets (KOT)</li>
          <li>Inventory Control</li>
          <li>Table Management</li>
          <li>Daily Sales Reports</li>
        </ul>
      </div>

      {/* Coaching Class Management Software */}
      <div className="service-card">
        <h3>Coaching Class Management Software</h3>
        <p>A complete digital solution for coaching institutes and training centers:</p>
        <ul>
          <li>Student admission & registration management</li>
          <li>Attendance tracking (batch-wise & subject-wise)</li>
          <li>Fee management with reminders</li>
          <li>Online exam & result processing</li>
          <li>Performance analytics & report cards</li>
          <li>SMS / Email notifications</li>
        </ul>
         <p><strong>Benefits:</strong>Improves administrative efficiency, reduces paperwork, and enhances communication with students and parents.</p>
      </div>
              
              {/* Salon Management Software */}
<div className="service-card">
  <h3>Salon Management Software</h3>
  <p>Designed for salons, spas, and beauty clinics to streamline operations.</p>
  <ul>
    <li>Online & offline appointment booking</li>
    <li>Customer database management</li>
    <li>Billing & POS integration</li>
    <li>Staff commission calculation</li>
    <li>Inventory tracking (products & consumables)</li>
    <li>Sales & performance reports</li>
  </ul>
  <p><strong>Benefits:</strong> Improves customer experience, increases repeat visits, and optimizes staff productivity.</p>
</div>

{/* HR Management Software */}
<div className="service-card">
  <h3>HR Management Software</h3>
  <p>A centralized system to manage complete employee lifecycle.</p>
  <ul>
    <li>Employee records management</li>
    <li>Payroll processing & salary slips</li>
    <li>Attendance & biometric integration</li>
    <li>Leave management system</li>
    <li>Performance appraisal tracking</li>
    <li>Statutory compliance support</li>
  </ul>
  <p><strong>Benefits:</strong> Reduces HR workload, improves payroll accuracy, and ensures compliance.</p>
</div>

{/* Website Design */}
<div className="service-card">
  <h3>Website Design</h3>
  <p>Professional website designing services focused on branding and user experience.</p>
  <ul>
    <li>Corporate website design</li>
    <li>Responsive layouts (Mobile friendly)</li>
    <li>UI/UX design</li>
    <li>Landing page creation</li>
    <li>Website redesign</li>
  </ul>
  <p><strong>Benefits:</strong> Creates strong digital presence and enhances brand credibility.</p>
</div>

{/* Web Design & Development */}
<div className="service-card">
  <h3>Web Design & Development</h3>
  <p>Complete end-to-end web development services.</p>
  <ul>
    <li>Custom web applications</li>
    <li>E-commerce website development</li>
    <li>CMS-based websites</li>
    <li>Portal development</li>
    <li>API integration</li>
  </ul>
  <p><strong>Benefits:</strong> Secure, scalable and performance-driven web solutions tailored to business needs.</p>
</div>

{/* Mobile App Development */}
<div className="service-card">
  <h3>Mobile App Development</h3>
  <p>Android & iOS app development for startups and enterprises.</p>
  <ul>
    <li>Native & hybrid app development</li>
    <li>Backend integration</li>
    <li>Admin dashboard integration</li>
    <li>App UI/UX design</li>
    <li>App store deployment</li>
  </ul>
  <p><strong>Benefits:</strong> Enhances customer engagement and expands business reach.</p>
</div>

{/* Retail Billing Software */}
<div className="service-card">
  <h3>Retail Billing Software</h3>
  <p>Advanced billing solution for retail shops and supermarkets.</p>
  <ul>
    <li>GST compliant billing</li>
    <li>Barcode scanning</li>
    <li>Inventory & stock management</li>
    <li>Customer loyalty management</li>
    <li>Daily sales & profit reports</li>
    <li>Multi-branch support</li>
  </ul>
  <p><strong>Benefits:</strong> Faster billing process, improved stock control, and better business insights.</p>
</div>


              </div>
            </div>
        </div>
      </section>



      {/* Why Our Services Section */}
      <section className="service-benefits">
        <div className="services-container">
          <h2>Why Choose Our Services?</h2>
          
          <div className="benefits-grid">
            <div className="benefit-item">
              <span className="benefit-icon">⭐</span>
              <h4>Verified Professionals</h4>
              <p>All service providers are carefully vetted and verified</p>
            </div>

            <div className="benefit-item">
              <span className="benefit-icon">🛡️</span>
              <h4>Safe & Secure</h4>
              <p>Your safety is our priority with secure payment options</p>
            </div>

            <div className="benefit-item">
              <span className="benefit-icon">💰</span>
              <h4>Transparent Pricing</h4>
              <p>No hidden charges, clear and upfront pricing</p>
            </div>

            <div className="benefit-item">
              <span className="benefit-icon">⏱️</span>
              <h4>On-time Service</h4>
              <p>Reliable and punctual service delivery</p>
            </div>

            <div className="benefit-item">
              <span className="benefit-icon">📞</span>
              <h4>24/7 Support</h4>
              <p>Round-the-clock customer support team</p>
            </div>

            <div className="benefit-item">
              <span className="benefit-icon">⭐</span>
              <h4>Quality Assurance</h4>
              <p>Premium quality service guaranteed</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="services-container">
          <h2>How It Works</h2>
          
          <div className="steps-grid">
            <div className="step-item">
              <div className="step-number">1</div>
              <h4>Browse Services</h4>
              <p>Explore our wide range of services by category</p>
            </div>

            <div className="step-item">
              <div className="step-number">2</div>
              <h4>Select Provider</h4>
              <p>Choose from verified professionals in your area</p>
            </div>

            <div className="step-item">
              <div className="step-number">3</div>
              <h4>Book Service</h4>
              <p>Schedule your service at your convenient time</p>
            </div>

            <div className="step-item">
              <div className="step-number">4</div>
              <h4>Get Service Done</h4>
              <p>Enjoy quality service from trusted professionals</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="services-container">
          <h2>Ready to Book a Service?</h2>
          <p>Connect with professional service providers in your area</p>
          <button className="service-cta-btn">Browse All Services</button>
        </div>
      </section>
    </>
  );
}

export default ServicePage;
